import script from "./Panels.vue?vue&type=script&setup=true&lang=ts"
export * from "./Panels.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__